import React from 'react'

const Tag2Icon = ({ fill = '#1F1F1F', ...props }) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_719_17125)'>
        <path
          d='M15.4749 0.547785C15.1316 0.204459 14.6671 0.00250244 14.2026 0.00250244L8.91133 0.0226981H8.89113C8.08331 0.083285 7.29568 0.446807 6.7302 1.01228L0.530136 7.17196C-0.176712 7.87881 -0.176712 9.05015 0.530136 9.757L6.2455 15.4724C6.58883 15.8157 7.05333 15.9975 7.55822 15.9975C8.06311 15.9975 8.50742 15.8157 8.83055 15.4522L14.97 9.3127C15.5557 8.74722 15.9192 7.97978 15.9798 7.15176V7.13157L16 1.8605C16 1.35561 15.8182 0.891111 15.4749 0.547785ZM10.1231 7.4345C9.25466 7.4345 8.54781 6.72765 8.54781 5.85924C8.54781 4.99083 9.25466 4.28398 10.1231 4.28398C10.9915 4.28398 11.6983 4.99083 11.6983 5.85924C11.6983 6.72765 10.9915 7.4345 10.1231 7.4345Z'
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id='clip0_719_17125'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Tag2Icon
